//@flow
import React from 'react';
import ProductImage from '../../ProductDetails/components/ProductImage.react';
import LazyLoad from 'react-lazyload';

import type ProductModel from '../../Stores/Products/productModel';

type Props = {
  products:ProductModel[],
};

const config = {
  title: 'Raise the office snack bar',
  subtitle: 'Sweet or savory, vegan or gluten free, there’s snacks to suit every taste and diet, no matter how picky your office is. All of our healthier office snacks are made with simple, high quality ingredients and they taste amazing too!',
  checks: [
    {
      text: 'No artificial flavors, colors or sweeteners',
    },
    {
      text: 'Clean ingredients',
    },
    {
      text: 'Less than 10g of sugar in all of our snacks',
    },
    {
      text: 'No corn syrup of any kind',
    },
    {
      text: 'No hydrogenated oils or MSG',
    },
    {
      text: 'We now offer a range of <a href="/adaptogens">adaptogenic snacks</a> (snacks with functional benefits like stress relief, enhanced focus, and increased energy).',
    },
  ],
};

const {title, subtitle, checks} = config;

export default function BeTheHeroSection(props:Props) {
  return (
    <div className="easy-section be-the-hero row">
      <div className="row-text md-down">
        {_getRowText("hide-lg-up")}
      </div>
      <div className="checkmark-text-container">
        {_getRowText("hide-md-down")}
        {_getCheckMarkText()}
        <LazyLoad>
          <div className="img-container products">
            {_getProducts(props.products)}
          </div>
        </LazyLoad>
      </div>
    </div>
  );
}

function _getProducts(products:ProductModel[]) {
  return products && products.map(product => {
    return (
      <ProductImage
        className="product-image"
        key={product.getId()}
        imageUrl={product.getSquareImageUrl(200, 200)}
        alt={product.getName()}
      />
    );
  });
}

function _getRowText(className:string) {
  return (
    <div className={`ae-benefits ${className}`}>
      <h2>
        {title}
      </h2>
      <div className="description text-2">
        {subtitle}
      </div>
    </div>
  );
}

function _getCheckMarkText() {
  return (
    <ul className="checkmarks">
      {checks.map((check, index) => (
        <li
          className="text-3"
          key={index}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{__html: check.text}}
        >
        </li>
      ))}
    </ul>
  );
}
